<template lang='pug'>
.new-address-container
    van-form(:form='form', layout='vertical', @submit='confirm')
        van-field(
            label='姓名',
            placeholder='收件人姓名',
            name='name',
            :rules='[{ required: true, message: "请输入姓名" }]',
            v-model='form.name'
        )
        van-field(
            label='手机',
            placeholder='收件人手机',
            type='number',
            name='phone',
            :rules='[{ validator, message: "请输入正确手机号" }]',
            v-model='form.phone'
        )
        van-field(
            label='省市区',
            readonly,
            clickable,
            :value='addressText',
            @click='showAddressPicker',
            placeholder='省市区'
        )
        van-popup(v-model='showPicker', position='bottom')
            van-picker(
                ref='addressPicker',
                show-toolbar,
                :columns='addressOptions',
                @cancel='showPicker = false',
                @confirm='onAddressConfirm'
            )
        van-field(
            label='详细地址',
            placeholder='精确到门牌号',
            :rules='[{ required: true, message: "请输入详细地址" }]',
            v-model='form.address.details'
        )
        van-button(
            type='primary',
            round,
            block,
            style='margin:16px 0',
            native-type='submit'
        ) 保存
</template>

<script>
import { setStorage, getStorage } from '@/utils/localstorage.js'
import { getAddress, updateRecipient, getRecipient, updateMember } from '@/service/member'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            form: {
                address: {
                    details: '',
                    province: '北京市',
                    city: '北京市',
                    district: '东城区'
                },
                name: '',
                phone: ''
            },
            addressOptions: [],
            showPicker: false,
        }
    },
    computed: {
        ...mapState(['memberInfo']),
        addressText() {
            if (this.form.address.province) {
                const { province, city, district } = this.form.address
                return province + ' ' + city + ' ' + district
            }
            return ''
        },
    },
    watch: {
        memberInfo: {
            // 预填充
            handler(v) {
                if (v.id) {
                    this.$nextTick(() => {
                        Object.assign(this.form, {
                            phone: v.phone,
                            name: v.personName && v.personName.fullName,
                            // address: v.address
                        })
                        for (let k in v.address) {
                            if (v.address[k]) {
                                this.form.address[k] = v.address[k]
                            }
                        }
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        validator(v) {
            return /^1[345789]\d{9}$/.test(v)
        },
        showAddressPicker() {
            this.showPicker = true
            this.$nextTick(() => {
                const { province, city, district } = this.form.address
                this.$refs.addressPicker.setValues([province, city, district])
            })
        },
        onAddressConfirm() {
            Object.assign(this.form.address, this.processAddress(this.$refs.addressPicker.getValues()))
            this.showPicker = false
        },
        processAddress(addressArr) {
            let ks = ['province', 'city', 'district']
            let address = {}
            ks.forEach((k, i) => {
                address[k] = addressArr[i] && addressArr[i].label || ''
            })
            return address
        },
        async confirm() {
            try {
                await updateRecipient(this.form, this.$route.params.id)
                // await updateMember({ ...values, personName: { fullName: values.name } })
                this.$message.success('保存成功')
                this.$router.push({ name: 'addressList' })
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        value2label(data) {
            for (let item of data) {
                item.text = item.label
                if (item.children) {
                    this.value2label(item.children)
                }
            }
            return data
        },
        async getAddressOptions() {
            // 获取全部省市
            let address = getStorage('ms_address_info')
            if (!(Array.isArray(address) && address.length > 0)) {
                address = this.value2label(await getAddress())
                setStorage('ms_address_info', address)
            }
            return address
        },
        async initFomm() {
            const { id } = this.$route.params
            if (id) {
                // 绑定表单域
                this.form = await getRecipient(id)
            }
        }
    },
    async created() {
        this.addressOptions = await this.getAddressOptions()
        this.initFomm()
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.new-address-container {
    padding: @spacing;
}
</style>